export default __webpack_public_path__ + "static/media/Weatherapp.ca74d886.PNG";